// Display-name validation — Phase 7 Block B.
//
// Rules (CLAUDE.md §"Display names"):
//   - 3-20 characters
//   - alphanumeric + underscore + hyphen
//   - Phase 7 does NOT enforce uniqueness; collisions allowed until
//     guilds need it (Phase 8+).
//
// Used by both the client (live preview as the user types) and the
// server (authoritative gate at the setDisplayName RPC boundary).

// CLAUDE.md §"Display names" locks the 3..20 character range. These are
// validation policy, not tunables — keeping them inline rather than
// adding `balance.player.displayName.*` matches the http-status / color
// constants pattern.
export const DISPLAY_NAME_MIN_LEN = 3; // contracts:allow-literal — locked policy
export const DISPLAY_NAME_MAX_LEN = 20; // contracts:allow-literal — locked policy

const DISPLAY_NAME_PATTERN = /^[a-zA-Z0-9_-]+$/;

export type DisplayNameValidation =
  | { ok: true }
  | { ok: false; code: "too_short" | "too_long" | "invalid_chars" | "empty"; reason: string };

export function validateDisplayName(name: string): DisplayNameValidation {
  if (name.length === 0) {
    return { ok: false, code: "empty", reason: "Display name cannot be empty." };
  }
  if (name.length < DISPLAY_NAME_MIN_LEN) {
    return {
      ok: false,
      code: "too_short",
      reason: `Display name must be at least ${DISPLAY_NAME_MIN_LEN} characters.`,
    };
  }
  if (name.length > DISPLAY_NAME_MAX_LEN) {
    return {
      ok: false,
      code: "too_long",
      reason: `Display name must be at most ${DISPLAY_NAME_MAX_LEN} characters.`,
    };
  }
  if (!DISPLAY_NAME_PATTERN.test(name)) {
    return {
      ok: false,
      code: "invalid_chars",
      reason: "Display name may only contain letters, numbers, underscore, and hyphen.",
    };
  }
  return { ok: true };
}
